import styled from 'styled-components';

export const HotelShortSection = styled.section`
  margin-bottom: 45px;
  
  @media(min-width: 768px) {
    margin-bottom: 50px;
  }
`;

export const HotelShortContainer = styled.div`
  padding: 0 25px;
  
  @media(min-width: 768px) {
    padding: 0 40px;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const HotelShortList = styled.ul`
  @media(min-width: 768px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100px;
  }
`;

export const HotelShortItem = styled.li`
  position: relative;
  
  display: flex;
  align-items: flex-start;
  padding-left: 30px;
  
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }) => theme.blue};
  text-transform: capitalize;
  
  address,
  span {
    font-weight: 400;
    color: ${({ theme }) => theme.black};
    font-style: normal;
  }
  
  span {
    width: 80px;
    flex-shrink: 0;
  }
  
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  
  @media(min-width: 768px) {
    width: 53.5%;
    margin-bottom: 22px;
    padding-left: 35px;
    
    font-size: 16px;
    line-height: 1;
    
    &:not(:last-child) {
      margin-bottom: 22px;
    }
    
    &:nth-child(1) {
      order: 3;
    }
  }
  
  @media(min-width: 1024px) {
    &:first-child {
      width: 46%;
    }
  }
`;

export const HotelShortIcon = styled.div`
  position: absolute;
  top: -5px;
  left: -5px;
  width: 30px;
  text-align: center;
`;
